const getStructureData = (campaign) => {
    if(!campaign || !campaign.structure)  {
        return {
            items: {},
            order: []
        }
    } else {
        return campaign.structure
    }
}

export default getStructureData